import { render, staticRenderFns } from "./StockLinkedInvoicesTable.vue?vue&type=template&id=c6449620&scoped=true"
import script from "./StockLinkedInvoicesTable.vue?vue&type=script&lang=js"
export * from "./StockLinkedInvoicesTable.vue?vue&type=script&lang=js"
import style0 from "./StockLinkedInvoicesTable.vue?vue&type=style&index=0&id=c6449620&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6449620",
  null
  
)

export default component.exports